/** Einheitlicher Seitenkopf mit Titel, Beschreibung und Aktionen. */
import { Body1, Caption1, Title3, makeStyles, tokens } from '@fluentui/react-components';
import type { ReactNode } from 'react';

const useStyles = makeStyles({
  header: {
    display: 'flex',
    flexWrap: 'wrap',
    alignItems: 'flex-start',
    justifyContent: 'space-between',
    gap: tokens.spacingHorizontalL,
    marginBottom: tokens.spacingVerticalL,
  },
  text: { display: 'flex', flexDirection: 'column', gap: tokens.spacingVerticalXXS, minWidth: '240px', flex: '1 1 auto' },
  description: { color: tokens.colorNeutralForeground2, maxWidth: '70ch' },
  meta: { color: tokens.colorNeutralForeground3 },
  actions: { display: 'flex', flexWrap: 'wrap', gap: tokens.spacingHorizontalS, alignItems: 'center' },
});

export function PageHeader({
  title,
  description,
  meta,
  actions,
}: {
  title: string;
  description?: string;
  meta?: string;
  actions?: ReactNode;
}) {
  const styles = useStyles();
  return (
    <header className={styles.header}>
      <div className={styles.text}>
        <Title3 as="h1">{title}</Title3>
        {description ? <Body1 className={styles.description}>{description}</Body1> : null}
        {meta ? <Caption1 className={styles.meta}>{meta}</Caption1> : null}
      </div>
      {actions ? <div className={styles.actions}>{actions}</div> : null}
    </header>
  );
}
